import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-6 col-xxxl-6 col-md-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "fw-black mb-12 lh-1" }
const _hoisted_6 = { class: "list ps-0 mb-0 list-unstyled mt-15" }
const _hoisted_7 = { class: "text-black fw-bold" }
const _hoisted_8 = {
  id: "earningChart",
  class: "chart"
}
const _hoisted_9 = { class: "col-lg-6 col-xxxl-6 col-md-6" }
const _hoisted_10 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box" }
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_12 = { class: "fw-black mb-12 lh-1" }
const _hoisted_13 = { class: "list ps-0 mb-0 list-unstyled mt-15" }
const _hoisted_14 = { class: "text-black fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Nombre d'emplacements ", -1)),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.sommeEmplacement), 1),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.abonnemntsParStatus, (abo, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "text-muted position-relative fw-medium"
              }, [
                _createTextVNode(" Emplacement " + _toDisplayString(abo.statut) + " = ", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(abo.nombre), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_apexchart, {
              type: "donut",
              height: "100",
              options: _ctx.earningChart,
              series: _ctx.demandes
            }, null, 8, ["options", "series"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Nombre d'usagers ", -1)),
          _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.somUsager), 1),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boitesParStatus, (boite, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "text-muted position-relative fw-medium"
              }, [
                _createTextVNode(" Usagers " + _toDisplayString(boite.etat) + "s = ", 1),
                _createElementVNode("span", _hoisted_14, _toDisplayString(boite.nombreUsager), 1)
              ]))
            }), 128))
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", {
            id: "earningChart",
            class: "chart"
          }, null, -1))
        ])
      ])
    ])
  ]))
}